import styled from 'styled-components';

export const StepSubtitleStyled = styled.p`
  margin: 0;
  max-width: 61.2rem;
`;
